module.exports = __webpack_public_path__ + "img/aMnkyJump_193x205.c6d01be2.png";